import { Component, OnInit } from '@angular/core';
import { CierreSesion } from 'src/app/services/cultura/cierre-sesion.ts.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private cierreSesion: CierreSesion) {}

  ngOnInit(): void {
    this.cierreSesion.startWatching();
  }
}
